import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 50px;
  align-items: flex-end;
  justify-content: space-between;

  strong {
    font-family: "Inter", Arial, Helvetica, sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 14.52px;
    margin-bottom: 11px;
  }
`;
